import { Grid, Button } from "@material-ui/core";
import { IconFileDownload } from "@tabler/icons-react";
import jsPDF from "jspdf";
import { Cost } from "../../../interfaces/costs/costs.interface";
import { visiblesCodes } from "../constants/constants";

interface props {
  cost: Cost;
}

const CostoDetalle = ({ cost }: props) => {
  const charges = cost.charges.filter((charge) =>
    visiblesCodes.includes(charge.code)
  );

  const handleDownload = () => {
    var source = document.getElementById("contentpdf");
    var doc = new jsPDF("l", "px", [
      source!.offsetWidth + 40,
      source!.offsetHeight + 300,
    ]);
    doc.html(source!, {
      margin: 20,
      // width: 912,
      callback: (pdf) => {
        pdf.save(`${cost.provider}.pdf`);
      },
    });
  };

  const _total =
    charges.map((ch) => Number(ch.per_unit)).reduce((a, b) => a + b, 0) +
    charges.map((ch) => Number(ch.base_rate)).reduce((a, b) => a + b, 0);

  return (
    <div>
      <div style={{ width: "100%", padding: 20 }} id="contentpdf">
        <div>
          <Grid container spacing={0}>
            <Grid item xs={6}>
              <Grid item xs={12}>
                <strong>Naviero: </strong>
                <span>{cost.provider}</span>
              </Grid>
              <Grid item xs={12}>
                <strong>Origen: </strong>
                <span>{cost.origin === "UNDEFINED" ? "-" : cost.origin}</span>
              </Grid>
              <Grid item xs={12}>
                <strong>Destino: </strong>
                <span>
                  {cost.destination === "UNDEFINED" ? "-" : cost.destination}
                </span>
              </Grid>
              <Grid item xs={12}>
                <strong>Contenedor: </strong>
                <span>{cost.container}</span>
              </Grid>
              <Grid item xs={12}>
                <strong>Vía: </strong>
                <span>{cost.via}</span>
              </Grid>
              <Grid item xs={12}>
                <strong>Community Code: </strong>
                <span>
                  {cost.commodity}&nbsp;({cost.commodity_description})
                </span>
              </Grid>
              <Grid item xs={12}>
                <strong>Time Frequency: </strong>
                <span>{cost.frequency}</span>
              </Grid>
              <Grid item xs={12}>
                <strong>Contract Number: </strong>
                <span>{cost.regla?.contract_number}</span>
              </Grid>

              <Grid item xs={12}>
                <strong>Total Cost: </strong>
                <span>{_total.toFixed(2)}</span>
              </Grid>
            </Grid>
            <Grid item xs={6}>
              <Grid item xs={6}>
                <strong>Valido Desde: </strong>
                <span>{cost.valid_from}</span>
              </Grid>
              <Grid item xs={6}>
                <strong>Valido Hasta: </strong>
                <span>{cost.valid_to}</span>
              </Grid>
            </Grid>
          </Grid>
        </div>
        <br />
        <table
          border={0}
          style={{
            width: "100%",
            border: "1px solid grey",
            borderCollapse: "collapse",
          }}
        >
          <thead
            style={{
              // borderBottom: "1px solid grey",
              background: "SlateGray",
              color: "white",
            }}
          >
            <tr style={{ height: 50 }}>
              <th style={{ width: 220 }}>Charge Code</th>
              <th align="left" style={{ width: 300 }}>
                Description
              </th>
              <th style={{ width: 100 }}>Currency</th>
              <th style={{ width: 100 }}>Units</th>
              <th style={{ width: 120 }}>Base Rate</th>
              <th style={{ width: 120 }}>Per Unit</th>
            </tr>
          </thead>
          <tbody>
            {charges.map((ch, index) => (
              <tr
                key={index}
                style={{
                  borderBottom: "1px solid grey",
                }}
              >
                <td align="center">{ch.code}</td>
                <td align="left">{ch.description}</td>
                <td align="center">{ch.currency}</td>
                <td align="center">{ch.units}</td>
                <td align="center">{ch.base_rate}</td>
                <td align="center">{ch.per_unit}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <br />
        <Grid container spacing={2}>
          <Grid item>
            <strong>Notas: </strong>
            <p style={{ whiteSpace: "pre-line" }}>{cost.regla?.notes}</p>
          </Grid>
        </Grid>
      </div>
      <Grid container justifyContent="flex-end">
        <Grid item>
          <Button
            startIcon={<IconFileDownload />}
            variant="contained"
            onClick={handleDownload}
          >
            Descargar PDF
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

export default CostoDetalle;
